define("ember-code-snippet/index", ["exports", "ember-code-snippet/-private/get-snippet"], function (_exports, _getSnippet) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  Object.defineProperty(_exports, "getCodeSnippet", {
    enumerable: true,
    get: function () {
      return _getSnippet.default;
    }
  });
});